<template>
    <div class="fill-height of-y">
        <v-row
                no-gutters
                class="of-y fill-height"
        >
            <v-col class="fill-height of-y" cols="3">
                <multi-select-list
                        :items="devices"
                        itemKey="id"
                        :showCheckBoxes="true"
                        :multiple="false"
                        headlineKey="description"
                        sub-line-key="lastSyncDisplay"
                        v-model="selectedDeviceID"
                        filterLabel="Filter Devices"
                >

                    <template #subLine="{value}">
                        <div class="d-flex align-center">
                            <div :class="value.deviceVersion !== latestVersion ? 'error--text' : null">
                                {{value.deviceVersion || '0.0.0'}} -
                            </div>
                            <div class="flex-grow-1">
                                {{value.lastSyncDisplay}}
                            </div>
                        </div>
                    </template>

                    <div slot="header" class="px-2 pt-2">
                        <v-btn
                                small
                                block
                                color="primary"
                                @click="createDeviceShow = !createDeviceShow"
                        >
                            <v-icon left>mdi-tablet-cellphone</v-icon>
                            Add Device
                        </v-btn>
                        <v-btn
                                class="mt-2"
                                small
                                block
                                color="primary"
                                @click="exportDevices"
                        >
                            Export
                        </v-btn>
                    </div>
                </multi-select-list>
            </v-col>
            <divider color="primary darken-1" :vertical="true"/>
            <v-col class="fill-height of-y pa-2" cols="4" v-if="!!selectedDevice">
                <v-card>
                    <modify-device :edit-device="selectedDevice" @save="upsertDevice($event)"/>
                </v-card>
            </v-col>
            <v-dialog
                    v-if="createDeviceShow"
                    v-model="createDeviceShow"
                    :width="400"
                    persistent
            >
                <v-card>
                    <modify-device :edit-device="createDeviceObj" @dismiss="createDeviceShow = !createDeviceShow" @save="upsertDevice($event)"/>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import MultiSelectList from "../../General/Multi Select List/MultiSelectList";
import ModifyPiece from "./ModifyDevice";
import {waitForEvent} from "../../../core/socket";
import Divider from "../../General/Divider";
import ModifyDevice from "./ModifyDevice";
import {exportStats} from "@/core/codeFunctions";
import {format} from "date-fns";

export default {
    components: {
        ModifyDevice,
        Divider,
        ModifyPiece,
        MultiSelectList
    },
    props: {},
    data() {
        return {
            selectedDeviceID: null,
            createDeviceObj: null,
            createDeviceShow: false,
        }
    },
    watch: {
        createDeviceShow(val) {
            if (val)
                this.createDeviceObj = {
                    id: null,
                    description: null,
                }
        }
    },
    methods: {
        exportDevices() {
            const headers = [
                {text: "Device Name", value: "description"},
                {text: "Last Sync", value: "lastSyncExport"},
                {text: "Device Version", value: "deviceVersion"},
            ]
            const data = [...this.devices.map(device => {
                return {
                    ...device,
                    lastSyncExport: device.lastSync ? format(new Date(device.lastSync), 'yyyy-MM-dd HH:mm:ss') : ''
                }
            })];

            exportStats('Devices Export.xlsx', 'Devices', headers, data)
        },
        async upsertDevice(event) {
            console.log(event)
            let {device, ref} = event;
            ref.loading = true;
            try {
                const eventID = await this.$newReq('POST', `setup/device`, device)
                const addedPieceID = (await waitForEvent(eventID)).devices.pop().id
                this.createDeviceShow = false
                this.selectedDeviceID = addedPieceID;
                this.$snack.info('Changes saved')
            } catch (e) {
                console.log(e)
                this.$snack.netWorkError()
            } finally {
                ref.loading = false
            }
        }

    },
    computed: {
        ...mapGetters(['devices']),
        selectedDevice() {
            if (!this.selectedDeviceID)
                return null
            return this.devices.filter(obj => obj.id === this.selectedDeviceID).pop()
        },
        latestVersion() {
            return [...this.devices].sort((a,b) => a.deviceVersion > b.deviceVersion ? 1 : -1).pop().deviceVersion
        }
    },
}
</script>

<style scoped>

</style>